module.exports = __webpack_public_path__ + "static/media/img2-3.dd8c7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img2-3.png
// module id = 2195
// module chunks = 3